import { defineStore } from 'pinia';
import type { IHistoryStore } from '../types/store-states.types';
import type { IHistoryItem, IHistoryItemData } from '../types/history.types';
import HistoryItemModel from '../models/history-item.model';

export const useHistoryStore = defineStore('au-history', {
  state: () => ({
    fullHistory: new Map(),
    lastItem: null,
  } as IHistoryStore),
  
  getters: {
    getFullHistory: (state) => state.fullHistory,
    getLastItem: (state) => state.lastItem,
  },

  actions: {
    addItem(historyItemData: IHistoryItemData) {
      const historyItem = new HistoryItemModel(historyItemData);
      this.filter((item) => item.data.stepName === historyItem.data.stepName);
      this.fullHistory.set(historyItem.id, historyItem);
      this.updateHistoryItemsPrev();
      this.updateLastHistoryItem();
    },

    filter(predicate: (historyItem: IHistoryItem) => boolean, shouldUpdate?: boolean) {
      this.fullHistory.forEach((historyItem, historyItemId) => {
        const shouldRemove = predicate(historyItem);
        if (shouldRemove) {
          this.fullHistory.delete(historyItemId);
        }
      });

      if (shouldUpdate) {
        this.updateHistoryItemsPrev();
        this.updateLastHistoryItem();
      }
    },

    removeItems(historyItemsIds: string[]) {
      this.filter((historyItem) => historyItemsIds.includes(historyItem.id), true);
    },

    updateHistoryItemsPrev() {
      const historyIds = this.fullHistory.keys();
      let prev: IHistoryItem['id'] | null = null;

      for (const historyItemId of historyIds) {
        if (!this.fullHistory.has(historyItemId)) continue;
        const historyItem = this.fullHistory.get(historyItemId)!;
        historyItem.prev = prev;
        this.fullHistory.set(historyItemId, historyItem);
        prev = historyItemId;
      }
    },

    updateLastHistoryItem(): IHistoryItem | null {
      if (!this.fullHistory.size) {
        this.lastItem = null;
        return this.lastItem;
      };

      const history = Array.from(this.fullHistory);
      const lastItem = history.pop() || null;

      this.lastItem = (lastItem?.length) ? lastItem[1] : null;
      return this.lastItem;
    }
  },
});
